import { put } from 'redux-saga/effects';
import { initCustomSetDeviationStream, initGallectionStream, initBrowseStream, initPostStream, initTierStream, initTierDeviationStream, initCommissionStream } from '../actions';
import { MediaSourceType } from '../types';
export default function*({ payload  }) {
    if (!payload) {
        return;
    }
    const { mediaSource , initialDeviationSet  } = payload;
    if ([
        MediaSourceType.GALLERY,
        MediaSourceType.COLLECTION,
        MediaSourceType.PRIVATE_COLLECTION,
        MediaSourceType.STASH
    ].includes(mediaSource)) {
        yield put(initGallectionStream());
    } else if (mediaSource === MediaSourceType.BROWSE) {
        yield put(initBrowseStream());
    } else if ([
        MediaSourceType.POLL,
        MediaSourceType.STATUS,
        MediaSourceType.JOURNAL,
        MediaSourceType.POSTS
    ].includes(mediaSource)) {
        yield put(initPostStream(mediaSource));
    } else if (mediaSource === MediaSourceType.TIER) {
        yield put(initTierStream());
    } else if (mediaSource === MediaSourceType.COMMISSIONS) {
        yield put(initCommissionStream());
    } else if ([
        MediaSourceType.TIER_DEVIATIONS,
        MediaSourceType.TIER_POSTS
    ].includes(mediaSource)) {
        yield put(initTierDeviationStream());
    } else if (mediaSource === MediaSourceType.CUSTOM_SET && initialDeviationSet) {
        yield put(initCustomSetDeviationStream(initialDeviationSet));
    }
}
